<template>
  <div>
    <v-dialog v-model="isOpen" width="1036px" class="hidden">
      <!-- eslint-disable-next-line max-len -->
      <media-upload :with-close-button="true" @close="close" :media="media" :windows="windows"></media-upload>
    </v-dialog>
  </div>
</template>

<script>
import MediaUpload from '@/components/MediaUpload.vue';

export default {
  props: ['media', 'windows'],
  components: {
    MediaUpload,
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    open() {
      this.isOpen = true;
    },

    close() {
      this.isOpen = false;
    },
  },
};
</script>
